var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('img',{attrs:{"src":require("../assets/img/back.png"),"alt":""},on:{"click":_vm.historyBack}}),_c('h1',[_vm._v(_vm._s(_vm.topNavTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }